import { Box, CircularProgress } from "@chakra-ui/react";

export default function FullPageLoader() {  
  return (
    <Box minH="32" alignItems="center" justifyContent="center" display="flex"
    >
      <CircularProgress color="gray.900" isIndeterminate />
    </Box>
  )
}